<div class="container-geral">
  <!-- <h2>Navegue pelas Funcionalidades</h2> -->
  <div class="container-atalhos">
    @for (funcionalidade of listaFuncionalidades; track funcionalidade.idFuncionalidade) {
      <a class="atalho-card" routerLink="{{funcionalidade.uri}}">
        <div class="icon-container">
          <span class="material-symbols-outlined">{{funcionalidade.googleIconClass}}</span>
        </div>
        <label>{{funcionalidade.nome}}</label>
      </a>
    } @empty {
      <p>Nenhuma funcionalidade disponível neste módulo.</p>
    }
  </div>
</div>